import html2Canvas from 'html2canvas'
import axios from 'axios';
import { saveAs } from 'file-saver'

let htmlImgData = {};
let divDomsArr = [];
export default{
  install (Vue, options) {
    Vue.prototype.getPdf = function (options) {
      return new Promise((resolve, reject) => {
        let hzDomArr = document.getElementsByClassName("contract-contdiv");
        let jsDomArr = document.getElementsByClassName("jiesuan-div");
        let htSize = hzDomArr.length;
        let jsSize = jsDomArr.length;
        let allDivSize = htSize + jsSize;
        if(allDivSize > 0){
          for(let i = 0; i < htSize; i++) {
            divDomsArr.push(hzDomArr[i]);
          }
          for (let m = 0; m < jsSize; m++) {
            divDomsArr.push(jsDomArr[m])
          }
          htmlImgData = {};
          getHtmlImgsFunc(0, allDivSize, options, resolve, reject)
        }
      })
    }
  },
}

function getHtmlImgsFunc(loopIndex, totalNumber, options, resolve, reject) {
  let divDom = divDomsArr[loopIndex];
  let id = ((divDom.attributes.contractId && divDom.attributes.contractId.value) || (divDom.attributes.jsId && divDom.attributes.jsId.value))
  let idStr = divDom.id;
  if (typeof htmlImgData[id] === "undefined") {
    htmlImgData[id] = {}
  }

  html2Canvas(document.querySelector("#" + idStr), {
    allowTaint: true,// 允许跨域图片
    useCORS: true, // 【重要】开启跨域配置
  }).then(function (canvas) {
    canvas.setAttribute("crossOrigin",'Anonymous')
    canvas.id = "mycanvas";
    let pageData = canvas.toDataURL('image/jpeg')
    let imgData = convertBase64UrlToBlob(pageData)
    if (idStr.indexOf('ht') > -1) {
      htmlImgData[id].htData = imgData
    } else if (idStr.indexOf('js') > -1) {
      htmlImgData[id].jsData = imgData
    }
    loopIndex++
    if (loopIndex < totalNumber) {
      getHtmlImgsFunc(loopIndex, totalNumber, options, resolve, reject)
    } else {
      gotoAjaxFunc(options,resolve, reject)
    }
  })
}

function convertBase64UrlToBlob(urlData){
  // 去掉url的头，并转换为byte
  let bytes = window.atob(urlData.split(',')[1]);
  // 处理异常,将ascii码小于0的转换为大于0
  let ab = new ArrayBuffer(bytes.length);
  let ia = new Uint8Array(ab);
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i);
  }
  return new Blob([ab], {type: 'image/png'});
}

function gotoAjaxFunc(options, resolve, reject) {
  console.log('--------gotoAjaxFunc--------')
  let formData = new FormData(); // 模拟表单对象
  let idsArr = []
  for (let k in htmlImgData) {
    let liId = k
    let liItem = htmlImgData[k]
    let htData = liItem.htData
    let jsData = liItem.jsData
    formData.append("imgArray", liItem)
    idsArr.push(liId)
    idsArr = idsArr.map(item => {if (item) {
      return item
    }})
    if (typeof htData !== "undefined") {
      let htName = 'htImg_' + liId
      formData.append(htName, htData)
    }
    if (typeof jsData !== "undefined") {
      let jsName = 'jsImg_' + liId
      formData.append(jsName, jsData)
    }
  }

  formData.append('idsArr', idsArr)
  let number = rand(1000,9999);
  let packName = new Date().getTime() + "" + number;
  let htCount = document.getElementsByClassName("contract-contdiv").length;
  let jsCount = document.getElementsByClassName("jiesuan-div").length;
  if (htCount + jsCount === 1) {
    // 单个合同的时候 用exportOneContract方法导出pdf文件
    if (htCount == 1) {
      exportOneContract(formData, packName, 1, options.ids, options.historyYear, options.historyMonth, resolve, reject)
      // exportOneContract(formData, packName, 1, options.ids, options.historyYear, options.historyMonth, options.isOpen, resolve, reject)
    } else {
      exportOneContract(formData, packName, 2, options.ids, options.historyYear, options.historyMonth, resolve, reject)
      // exportOneContract(formData, packName, 2, options.ids, options.historyYear, options.historyMonth, options.isOpen, resolve, reject)
    }
  } else if (htCount > 1 || (htCount === 1 && jsCount > 0)) {
    exportContract(formData, packName, options.ids, options.historyYear, options.historyMonth, resolve, reject)
    // exportContract(formData, packName, options.ids, options.historyYear, options.historyMonth, options.isOpen, resolve, reject)
  }
}

function rand(min,max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

function loadUrlNew(exportUrl) {
 
  const isFileDownload = /\.zip/i.test(exportUrl);
  if (isFileDownload) {
      // 使用fetch API下载文件
      fetch(exportUrl)
          .then(response => {
              if (!response.ok) {
                  throw new Error('网络响应不正常');
              }
              
              // 尝试从Content-Disposition获取文件名
              const contentDisposition = response.headers.get('content-disposition');
              let fileName = '';
              
              if (contentDisposition) {
                  const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                  if (fileNameMatch && fileNameMatch[1]) {
                      fileName = fileNameMatch[1].replace(/['"]/g, '');
                  }
              }
              
              // 如果无法从header获取文件名，从URL提取
              if (!fileName) {
                  const urlParts = exportUrl.split('/');
                  fileName = urlParts[urlParts.length - 1].split('?')[0];
              }
              
              return response.blob().then(blob => ({ blob, fileName }));
          })
          .then(({ blob, fileName }) => {
              // 使用file-saver库保存文件
              saveAs(blob, fileName);
          })
          .catch(error => {
           
              // 如果下载失败，回退到window.open方法
              window.open(exportUrl);
          });
  } else {
      // 非文件下载使用window.open
      window.open(exportUrl);
  }
}
// 单个合同下载pdf（不包含结算单） 仅结算单
function exportOneContract(formData, packName, downloadType, ids, historyYear, historyMonth, resolve, reject) {
  axios.post("/oms-consignor-pc/order/contract/downloadContractToPdf?downloadType=" + downloadType + '&ids=' + ids + '&historyYear=' + historyYear + '&historyMonth=' + historyMonth).then(response => {
  // axios.post("/oms-consignor-pc/order/contract/downloadContractToPdf?downloadType=" + downloadType + '&ids=' + ids + '&historyYear=' + historyYear + '&historyMonth=' + historyMonth + '&isOpen=' + isOpen).then(response => {
    if (response && response.data.code == 200) {
     
      if (response.data.data.fileOssSignPath) {
        loadUrlNew(response.data.data.fileOssSignPath)
        // axios.post('/oms-consignor-pc/oms/file/downloadOssUrl?fileUrl=' + response.data.data.filePath, formData, {
        //   responseType: 'blob',
        //   "Content-Type": 'application/x-www-form-urlencoded'
        // }).then(res => {
        //   let blob = new Blob([res.data], {type: 'text/pdf'});
        //   let csvUrl = URL.createObjectURL(blob);
        //   let link = document.createElement('a');
        //   link.href = csvUrl;
        //   link.download = response.data.data.filePath;
        //   link.click();
  
        // })
      } else {
        this.$message.error('保存失败，请稍后重试！')
      }
    } else {
      this.$message.error(response.data.msg)
    }
    resolve('finish')
  }).catch((err) => {
    this.$message.error(err.data.msg);
    reject()
  })
}

// 多个合同下载 压缩包 & 单个合同且包含结算单
function exportContract(formData, packName, ids, historyYear, historyMonth, resolve, reject) {
  axios.post("/oms-consignor-pc/order/contract/downloadContractToPdf?downloadType=1&ids=" + ids + '&historyYear=' + historyYear + '&historyMonth=' + historyMonth).then(response => {
// function exportContract(formData, packName, ids, historyYear, isOpen, resolve, reject) {
  // axios.post("/oms-consignor-pc/order/contract/downloadContractToPdf?downloadType=1&ids=" + ids + '&historyYear=' + historyYear + '&historyMonth=' + historyMonth + '&isOpen=' + isOpen).then(response => {
    if (response && response.data.code == 200) {
      if (response.data.data.fileOssSignPath) {
        loadUrlNew(response.data.data.fileOssSignPath)
        // axios.post('/oms-consignor-pc/oms/file/downloadOssUrl?fileUrl=' + response.data.data.filePath, formData, {
        //   responseType: 'blob',
        //   "Content-Type": 'application/x-www-form-urlencoded'
        // }).then(res => {
        //   let blob = new Blob([res.data], {type: 'text/zip'});
        //   let csvUrl = URL.createObjectURL(blob);
        //   let link = document.createElement('a');
        //   link.href = csvUrl;
        //   link.download = response.data.data.filePath;
        //   link.click();
        // })
      } else {
        this.$message.error('保存失败，请稍后重试！')
      }
    } else {
      this.$message.error(response.data.msg)
    }
    resolve('finish')
    
  }).catch((err) => {
    this.$message.error(err.data.msg);
    reject()
  })
}
